import styled from "styled-components";

export const EventScheduleWrapper = styled.div<{
  isApp: number | null;
}>`
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  width: 100%;
  height: 100vh;
  overflow: auto;
`;

export const EventScheduleHeader = styled.div<{
  isApp: number | null;
}>`
  position: relative;
  width: 100%;
  top: ${(p) => (p.isApp ? `-${p.isApp}px` : "0px")};

  > .banner {
    > img {
      width: 100%;
    }
  }

  > .title {
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: linear-gradient(
      277.27deg,
      #6c36d6 5.66%,
      #955fff 60.16%,
      #ccb2ff 94.34%
    );
    height: 33px;
    border-radius: 14px;
    line-height: 33px;
    text-align: center;
    color: #ffffff;
    font-weight: 400;
    font-size: 18px;
    padding: 0 12px;

    > span {
      font-weight: 600;
    }
  }

  > .close {
    position: absolute;
    z-index: 1;
    top: ${(p) => (p.isApp ? `${p.isApp + 13}px` : "13px")};
    left: 20px;

    > img {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }
`;

export const EventScheduleContentWrapper = styled.div<{
  isApp: number | null;
}>`
  margin-top: ${(p) => (p.isApp ? `-${p.isApp}px` : "0px")};
`;

export const EventScheduleTabWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 41px;

  > .tab {
    flex: 1;
    line-height: 41px;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    color: #a4a4a4;

    &.selected {
      color: var(--Black-400, #444444);
      border-bottom: 1px solid #000;
    }
  }
`;
